// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"3dc025f1","324":"43ed8e8b"}[chunkId] + ".chunk.css";
};